import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVOrderdetCom} from '../containers'
function SVOrderdetComPage() {
    console.log('sv****SVOrderdetComPage')
    let { id,orderId } = useParams();
    let svparams = { 'id': id, orderId:orderId}
    console.log('sv****SVOrderdetComPage', svparams)
    return (
        <SVOrderdetCom svparams= {svparams} />
        
    );
}
export default SVOrderdetComPage